'use es6';

export const IMAGE = 'IMAGE';
export const TEXT = 'TEXT';
export const MD = 'MD';
export const BINARY = 'BINARY';
export const FONT = 'FONT';